import React, { useEffect, useState, useContext } from "react";

import { IoPersonOutline } from "react-icons/io5";
import { IoAdd } from "react-icons/io5";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
// import PaymentRecommended from "../../Components/PaymentRecommended";
// import CustomizedProfile from "./CustomizedProfile.js";
import Button from "@mui/material/Button";

import Modal from "@mui/material/Modal";
// progress bar
import PropTypes, { func } from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Link, Route, useLocation, useNavigate } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import { IoShareSocialOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaShare } from "react-icons/fa";
import { useFormik } from "formik";
import { object, string } from "yup";
import { useAccordionButton } from "react-bootstrap";
import { colors } from "@mui/material";
import { IoIosClose } from "react-icons/io";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { FaArrowLeftLong } from "react-icons/fa6";



const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  py: 4,
  px: 2,
};
export function MatchmakerPlans() {
  const [loading, setLoading] = useState(false);
  const storedData =
    JSON.parse(sessionStorage.getItem("matchmakerProfileData")) || {};
  const { agentId, matchmakerName, planType, publicToken,email,mobile } = storedData;

  const navigate = useNavigate();

  const [paymentMode, setPaymentMode] = useState("");
  const [plans, setPlan] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState();

  // modal state
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // payment mode modal state
  const [paymentopen, setPaymentOpen] = React.useState(false);
  const handlePaymentOpen = () => setPaymentOpen(true);
  const handlePaymentClose = () => setPaymentOpen(false);


  const [promocodeError, setpromocodeError] = useState();


  const PromocodeSchema = object({
    promo_code: string().required("Enter Promocode"),
  });
  const formik = useFormik({
    initialValues: {
      promo_code: "",
    },
    validationSchema: PromocodeSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const promocodeResponse = await axiosInstance_agent.post(
          "admin/promo-codes",
          values
        );

        if (promocodeResponse.data.status === true) {
          toast.success("Promocode Applied");
          localStorage.setItem("appliedPromoCode", values.promo_code);
          resetForm();
          setpromocodeError(""); // clear any previous error
          // handlePayment();
          handleClose();
          handlePaymentOpen();
        } else {
          setpromocodeError("Invalid Promocode");
        }
      } catch (error) {
        console.log("Submission Failed", error);
        const message = error.response?.data?.message || "Submission Failed";
        toast.error(message);
        setpromocodeError(message);
      }
    },
  });

  async function LoadPlans() {
    try {
      const response = await axiosInstance_agent.get("admin/plans");
      const planData = response.data.data;
      setPlan(planData);
      console.log(planData);
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }
   useEffect(() => {
    LoadPlans();
  }, []);
  const handlePaymentChange = (e) => {
    setPaymentMode(e.target.value);
  };

  const storedPromoCode = localStorage.getItem("appliedPromoCode") || "";
  async function handlePaymentType() {
    const payload ={
      plan_type: selectedPlan,
          promo_code: storedPromoCode || "",
          user_id: agentId,
          payment_method:paymentMode,
    }
    try {
      setLoading(true);
      const response = await axiosInstance_agent.post("admin/cash-payment",payload);
      if(response.status===200 || response.data.status === true){
         console.log("Selected Payment Mode:", paymentMode);
      if (paymentMode === "cash") {
        handlePaymentClose();
        toast.success(response.data.message || "Payment successfull!");
        setTimeout(() => {
            navigate("/payment-success");
        },3000);
       
      } else if (paymentMode === "online") {
        handlePaymentClose();
        // handleOpen();
        handlePayment();
      }

      }

     
    } catch (error) {
      console.log("Failed to submit");
    }finally{
      setLoading(false);
    }
  }


  function handlePlanName(plan) {
    setSelectedPlan(plan);
  }

  // razor pay payment

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  async function handlePayment() {
    try {
      // console.log("plan", selectedPlan);

      // send data to razorpay/create-order api
      const storedPromoCode = localStorage.getItem("appliedPromoCode") || "";

      const response = await axiosInstance_agent.post(
        "admin/razorpay/create-order",
        {
          plan_type: selectedPlan,
          promo_code: storedPromoCode || "",
          user_id: agentId,
        }
      );
      console.log("admin/razorpay/create-order", response);
      const order_id = response.data.order_id;
      const key_id = response.data.key_id;
      const amount = response.data.amount;
      const promoCode = response.data.promo_code;

      console.log("Sec key", key_id);

      const currency = response.data.currency;

      console.log("order_id:", order_id);
      console.log("key_id:", key_id);
      console.log("amount:", amount);

      //Initiate Razorpay Payment
      const options = {
        key: key_id,
        amount: parseInt(amount, 10),
        // KEY_ID: rzp_live_d5gbZDoIVFB1IV,
        // KEY_SECRET: Qkt1dVNqEYVaTgYbhk69AK8Q,
        currency: currency,
        order_id: order_id,
        handler: async function (response) {
          //below response in console visible after successful payment
          console.log("Payment Success:", response);

          // Send Payment details to razorpay/verify-payment
          try {
            const verifyResponse = await axiosInstance_agent.post(
              "admin/razorpay/verify-payment",
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                promo_code: storedPromoCode,
                user_id: agentId,
              }
            );
            if (verifyResponse.data.status === "success") {
              // toast.success(verifyResponse.data.message||"Payment successful! Redirecting...");
              // setTimeout(() => navigate("/payment-success"), 3000);
              navigate("/payment-success");
              localStorage.removeItem("appliedPromoCode");
            }
          } catch (error) {
            console.error("Error saving payment details:", error);
            // toast.error(
            //   "Payment recorded, but there was an issue saving your details."
            // );
            // setTimeout(() => navigate("/payment-failed"), 3000);
            navigate("/payment-failed");
          }
        },
        prefill: {
          name: matchmakerName,
          email: email,
          contact: mobile,
        },
        theme: {
          color: "#3399cc",
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            toast.warning("Payment was canceled! Please try again.");
            console.log("User closed the payment modal.");
            setTimeout(() => navigate("/matchmaker-plans"), 3000);
            handleClose();
          },
        },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.log("Error", error);
    }
  }
 
  return (
    <>
      <ToastContainer />
        {loading && (
              <div className="loader-overlay">
                <CircularProgress style={{ color: "#f24464" }} />
              </div>
            )}
      <div className="plansMainContainer">
        <div className="mx-3">
          <FaArrowLeftLong
            onClick={() =>
              navigate("/matchmaker-profiles-uploaded", {
                // state: {
                //   userId: userId,
                //   matchmakerName: matchmakerName,
                //   planType:planType,
                // },
              })
            }
            style={{ cursor: "pointer" }}
          />
          <span className="ms-2">Back</span>
        </div>
        <div className="choose-plan-section">
          <div className="plansContent">
            <div>Join 1200+ Wedding Agents Already on Our Premium Plan</div>
            <div>Tailored for all wedding professionals</div>
            <div>Why Upgrade?</div>


            <div className="plansContentList">
              <ul>
                <li>
                  Unlimited Profile Listings = Showcase all your clients with no
                  limits. More profiles = more visibility, more matches, and
                  more growth.
                </li>
                <li>
                  Boost Your Credibility Appear more professional and
                  trustworthy—attract serious, high-value clients with ease.
                </li>
                <li>
                  Priority Visibility Get featured more often and stand out in
                  search results to gain better exposure.
                </li>
                <li>
                  Exclusive Premium Features Access tools and benefits tailored
                  to help you succeed in a competitive market.
                </li>
                <li>
                  One-Time Annual Plan Simple, affordable, and powerful—no
                  monthly fees, just one smart upgrade for the whole year.
                </li>
              </ul>
            </div>
          </div>
          <div className="plansCardpart" id="paymentRecommended">
            {plans.length > 0 && planType ==="Basic" && (
              <div className="plansCard">
                <div className="plan-type">{plans[0].plan_name}</div>
                <div className="plan-cost">Free</div>
                <div className="plan-data">
                  <div>Begin Your Journey</div>
                  <div>Perfect for new agents testing the platform.</div>
                </div>
                <ul className="plancardList">
                  <li>Create and manage up to 5 client profiles.</li>
                  <li>Share profiles seamlessly across WhatsApps.</li>
                  <li>
                    Access to standard support to help with your onboarding.
                  </li>
                  <li>No credit card required – try it risk-free.</li>
                  <li>A great way to test the platform before upgrading.</li>
                </ul>
                <div className="plan-btnCurrent">
                  {planType === "Basic" ? "Current Plan" : ""}
                </div>
              </div>
            )}

            {plans.length > 1 && planType ==="Basic" && (
              <div className="plansActiveCard">
                <div className="plan-active-type">
                  {plans[1].plan_name === "Recommended"
                    ? "Standard"
                    : plans[1].plan_name}
                </div>
                <div className="plan-active-cost">
                  ₹{plans[1].plan_price}
                  {plans[1].plan_validity > 0 && (
                    <span style={{ fontSize: "18px" }}>
                      /{plans[1].plan_validity} months
                    </span>
                  )}
                </div>
                <div className="plan-offer-price-standard">
                  <p className="strike-price-standard">
                    ₹{plans[1].strike_price}
                  </p>
                  <p className="per-day-price-standard">50% Off • ₹8/day</p>
                </div>
                <div className="plan-active-data">
                  <div>Smartly Designed for Growing Agents</div>
                  <div>Ideal for expanding and managing your client base.</div>
                </div>
                <ul className="plancardActiveList">
                  <li>Add and manage up to 350 client profiles.</li>
                  <li>Unlimited client requests.</li>
                  <li>Earn referral income.</li>
                  <li>Share profiles across any platform.</li>
                  <li>Dedicated public page.</li>
                  <li>Advanced search filters.</li>
                  <li>Quick support access.</li>
                  {/* <li>{translations[language].card2_li8}</li> */}
                </ul>
                <div
                  className="plan-btnActive"
                  // onClick={() =>
                  //   handlePayment(plans[1].plan_name, plans[1].plan_price)
                  // }
                  onClick={() => {
                    handlePlanName(plans[1].plan_name, plans[1].plan_price);
                    handleOpen();
                    // handlePaymentOpen();
                  }}
                >
                  {planType === plans[1].plan_name
                    ? "Active Plan"
                    : "Choose Plan"}
                </div>
              </div>
            )}

            {plans.length > 2 && (planType === "Recommended" || planType === "Basic")  && (
              <div className="plansCard">
                <div className="plan-type">{plans[2].plan_name}</div>
                <div className="plan-cost">
                  ₹{plans[2].plan_price}
                  {plans[2].plan_validity > 0 && (
                    <span style={{ fontSize: "18px", color: "#9D9496" }}>
                      /{plans[2].plan_validity} months
                    </span>
                  )}
                </div>
                <div className="plan-offer-price-premium">
                  <p className="strike-price-premium">
                    ₹{plans[2].strike_price}
                  </p>
                  <p className="per-day-price-premium">50% Off • ₹18/day</p>
                </div>
                <div className="plan-data">
                  <div>Agent's Favorite</div>
                  <div>
                    {" "}
                    Chosen by 80% of top-performing agents for its advanced
                    features and flexibility.
                  </div>
                </div>
                <ul className="plancardList">
                  <li>Add and manage up to 1000 client profiles.</li>
                  <li>Unlimited client requests.</li>
                  <li>Multi-platform profile sharing.</li>
                  <li>Dedicated onboarding for new profiles (up to 1000).</li>
                  <li>Share profiles to any platform.</li>
                  <li>Dedicated public page.</li>
                  <li>Advanced search filters.</li>
                  <li>Priority support access.</li>
                  {/* <li>{translations[language].card3_li9}</li> */}
                </ul>
                <div
                  className="plan-btnPremium"
                  // onClick={() =>
                  //   handlePayment(plans[2].plan_name, plans[2].plan_price)
                  // }
                  onClick={() => {
                    handlePlanName(plans[2].plan_name, plans[2].plan_price);
                    handleOpen();
                    // handlePaymentOpen();
                  }}
                >
                  {planType === plans[2].plan_name
                    ? "Active Plan"
                    : "Choose Plan"}
                </div>
              </div>
            )}

            <div className="plansCard">
              <div className="plan-type">Create Your Custom Profile</div>
              <div className="plan-data">
                <div>Create Your Custom Profile</div>
              </div>
              <ul className="plancardList">
                <li>Custom Profile Upload System.</li>
                <li>Custom Onboarding Page with Bureau Branding.</li>
                <li>Custom Public Page Design (Colors, Logo, Contact Info).</li>
                <li>White-labeled Bureau Experience.</li>
                <li>Dedicated Support Manager.</li>
                <li>Includes All Premium Features.</li>
              </ul>
              <div
                className="plan-btnPremium"
                onClick={() => {
                  navigate("/contact-us");
                }}
              >
                contact us
              </div>
            </div>
          </div>

          {/* promocode modal */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="promocode-container"
          >
            <Box sx={style}>
              <div
                className="fs-4 "
                style={{
                  position: "absolute",
                  top: 2,
                  right: 8,

                  cursor: "pointer",
                  zIndex: 1,
                }}
                onClick={handleClose}
              >
                <IoIosClose size={28} />
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="d-flex justify-content-between mt-2">
                  <div className="promocode-text">Enter Your Promocode</div>

                 <div className="text-skip" onClick={() => { handleClose(); handlePaymentOpen(); }}>

                    Skip
                  </div>
                </div>
                <div className="promocodeInput">
                  <input
                    type="text"
                    placeholder="Promocode"
                    id="promo_code"
                    value={formik.values.promo_code}
                    onChange={formik.handleChange}
                  />
                  {/* {formik.touched.promo_code &&
                        formik.errors.promo_code && (
                          <div className="text-danger">
                            {formik.errors.promo_code}
                          </div>
                        )} */}
                </div>
                <div className="text-danger mt-2 mb-2">{promocodeError}</div>

                <div className="btnPromoSubmit">
                  <button type="submit">Submit</button>
                </div>
              </form>
            </Box>
          </Modal>
          {/* payment mode modal  */}
          <Modal
            open={paymentopen}
            onClose={handlePaymentClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="promocode-container"
          >
            <Box sx={style}>
              <div
                className="fs-4 "
                style={{
                  position: "absolute",
                  top: 2,
                  right: 8,

                  cursor: "pointer",
                  zIndex: 1,
                }}
                onClick={handlePaymentClose}
              >
                <IoIosClose size={28} />
              </div>

              <div className="d-flex justify-content-between mt-2">
                <div className="payment-text">Choose Payment Mode</div>
              </div>
              <div className="paymentModeInput">
                {" "}
                <input
                  type="radio"
                  name="mode"
                  value="cash"
                  checked={paymentMode === "cash"}
                  onChange={handlePaymentChange}
                />{" "}
                <span>Cash</span>
              </div>
              <div className="paymentModeInput">
                <input
                  type="radio"
                  name="mode"
                  value="online"
                  checked={paymentMode === "online"}
                  onChange={handlePaymentChange}
                />{" "}
                <span>Online</span>
              </div>

              <div className="btnPromoSubmit">
                <button type="submit" onClick={handlePaymentType}>
                  Proceed
                </button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}
